import { defineMessages } from 'react-intl';

export default defineMessages({
    repayAmount: {
        id: '_.early_repayment.choose_repayment_amount.repay_amount',
        defaultMessage: 'I want to repay'
    }
});
